module.exports = {"id":"f8545b15-ed8f-42e8-a4de-59e29bfe62cd","name":"managers","items":[{"text":"","type":"inline","items":[{"name":"full-name","props":{"hidden":true,"formula":{"name":"join","arguments":{"targets":["first-name","last-name"]}},"width":"0"},"text":"","type":"text-field"},{"name":"first-name","props":{"label":"First Name","required":true,"width":"6"},"text":"","type":"text-field"},{"name":"last-name","props":{"label":"Last Name","required":true,"width":"6"},"text":"","type":"text-field"}]}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/entity-support-premium/data_table_forms/managers.json
// module id = uh9r
// module chunks = 0